import React, {useCallback} from 'react';
import FullCalendar, {EventInput} from '@fullcalendar/react'
import allLocales from '@fullcalendar/core/locales-all';
import apiClient from 'utils/apiClient';
import useHandleError from 'utils/useHandleError';
import { useLocaleContext } from 'context/LocaleContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

const Calendar: React.FC<any> = ({ url, events, locales, saveData, adminView = false, refetchEvents, calendarDate, ...restProps }) => {
    const { locale } = useLocaleContext();
    const [handleError] = useHandleError();
    const navigate = useNavigate();
    const params = useParams();
    const intl = useIntl()
    const tab = params.tab;

    const fetchEvents = useCallback((info: any, successCallback: (events: EventInput[]) => void, failureCallback: (error: { message: string; response?: any; }) => void) => {
        apiClient.request(url, info, 'GET').then((response: any) => {
            if ("error" in response) {
                throw response
            };

            successCallback(response.data);
        }).catch((error: any) => {
            handleError(error)
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetchEvents]);
      
    const handleEventClick = (clickInfo: any) => {
        const event = clickInfo.event;

        const sessionId = event.id;
        const extendedProps = event.extendedProps;
        const lectureId = extendedProps?.lecturesId;
        if (!adminView) {
            if (sessionId && lectureId) {
                navigate(`/my-lectures/${lectureId}/session/${sessionId}` + (tab ? ('/' + tab) : '') + (calendarDate ? ('/' + calendarDate) : ''));
            } else {
                handleError({
                    message: intl.formatMessage({ id: 'lecture.session.missing_id' }),
                });
            }
        }
    };

    return <FullCalendar
        firstDay={1}
        eventTimeFormat={{ // like '14:30:00'
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            meridiem: false
        }}
        locales={allLocales}
        locale={locale ?? 'en'}
        events={!!url ? fetchEvents : events}
        eventClick={handleEventClick}
        {...restProps} />
}

export default Calendar;

